<template>
	<v-form
		><v-container>
			<v-row
				><v-col> <h1>Add new Airplane</h1></v-col> </v-row
			><v-row
				><v-col>
					<v-alert
						type="error"
						:text="error"
						v-model="error"
					></v-alert> </v-col></v-row
			><v-row>
				<v-col>
					<v-text-field
						v-model="registration"
						label="Registration"
						required
					></v-text-field>
				</v-col>

				<v-col>
					<AirportInput @returnValue="updateBase" label="Base Airport"
				/></v-col>
			</v-row>
			<v-row>
				<v-col>
					<TypeInput
						@returnValue="updateType"
						label="Type"
						:url="process.env.VUE_APP_BACKEND_URL + '/plane/getPlaneType'"
					/>
				</v-col>
				<v-col>
					<file-pond
						accepted-file-types="image/jpeg, image/png"
						name="PlanePicture"
						ref="pond"
						label-idle="Picture"
					/>
				</v-col>
			</v-row>
			<v-row
				><v-col>
					<v-btn @click="submit()">Save</v-btn>
					<v-btn @click="this.$emit('closeOverlay')">Close</v-btn>
				</v-col>
			</v-row></v-container
		></v-form
	>
</template>

<script>
import axios from "axios";
import TypeInput from "./TypeInput.vue";
import AirportInput from "@/components/AirportInput";
import { mapState } from "vuex";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

const FilePond = vueFilePond(
	FilePondPluginFileValidateSize,
	FilePondPluginImagePreview,
	FilePondPluginFileValidateType
);

export default {
	emits: ["closeOverlay"],
	data: () => ({
		registration: null,
		type: "",
		error: null,
		planepicture: null,
		base: "",
	}),
	components: { FilePond, TypeInput, TypeInput, AirportInput },
	computed: {
		...mapState({
			token: "token",
		}),
	},
	methods: {
		updateBase(val) {
			this.base = val;
		},
		updateType(val) {
			this.type = val;
		},
		submit() {
			var data = new FormData();
			data.append("registration", this.registration);
			data.append("type", this.type.value);
			data.append("base", this.base.value);
			try {
				data.append(
					"planepicture",
					this.$refs.pond.getFile(0).file,
					this.$refs.pond.getFile(0).filename
				);
			} catch {
				console.log("No file uploaded");
			}
			console.log(data);
			try {
				axios
					.post(process.env.VUE_APP_BACKEND_URL + "/plane/", data, {
						headers: {
							Authorization: "bearer " + this.token,
							"Content-Type": "multipart/form-data",
						},
					})
					.catch((err) => {
						this.error = err.message;
						console.log(err.message);
					});
				this.$emit("closeOverlay");
			} catch (e) {
				this.error = e.message;
				console.log(e.message);
			}
		},
	},
};
</script>

<style></style>
